
import { Text, Box, Flex, Button } from 'rebass';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useRef, useState, useEffect } from 'react';
import useSWR from 'swr';
import { BiEditAlt } from "react-icons/bi";
import { BsPlusCircleFill } from "react-icons/bs";
import { CgArrowRightR } from "react-icons/cg";
import { FaRegTrashAlt } from "react-icons/fa";
import useOutsideClick from 'use-onclickoutside';
import { HeaderWrap } from './styled';
import { getCoverUrl, isValidDateString } from '../../helper';
import { selectStory, selectStoryCover } from '../../selectors';
import { useStoryDate } from '../../hooks';
import Tippy from '@tippy.js/react';
// import Default_PreviewPhoto from '../../assets/Default_PreviewPhoto.png';
import useEntity from 'entities/hooks/use-entity';
import useLocation from 'app/hooks/location';
import useHistory from 'app/hooks/history';
import { TooltipWrap } from 'stories/story-detail-header/styled';
import { ChapterList } from 'stories/list/item/index';
import { updateStory } from 'stories/api';
import { useJournalsChaptersSWR } from 'collections/api';
import DetailHeaderButton from 'app/detail/button';
import useToggle from 'app/hooks/toggle';
import DeleteModal from '../../delete/modal';
import { bodyWithLockVersion } from 'app/form/helper';
import useEntities from 'entities/hooks/use-entities';
import { useDrawer } from 'contexts/DrawerContext';
import EditButtons from './edit';

export const EditorHeaderOptions = ({ story, isTooltipOpen, setTooltipOpen, handleEditSettingClick, updateChapter }) => {
  const [on, toggle] = useToggle();
  const wrapper = useRef(null);

  useOutsideClick(wrapper, () => {
    setTooltipOpen(false)
  });
  const allChapters = useEntities('chapter')

  return (
    <Flex alignItems="center">
      {on && <DeleteModal onClose={toggle} />}

      <Button
        variant={'outline'}
        sx={{ display: 'flex', alignItems: 'center', borderRadius: '23px', boxShadow: "0 0 5px 0 rgba(155, 89, 182, 0.15) inset;" }}
        onClick={handleEditSettingClick}
        height="40px"
        my={2}
        px={2}
      >
        <BiEditAlt color="#9B59B6" size={18} />&nbsp; Edit Header
      </Button>
      {(Object.keys(allChapters || {}) || []).length === 0 ? null : <Tippy
        content={<TooltipWrap>
          <Tippy
            content={
              <TooltipWrap ref={wrapper}>
                <Text fontFamily="Poppins" fontSize={18} py={2} lineHeight="165%" sx={{
                  boxShadow: '0px 1px 0px 0px #F0F0F0'
                }}>Add to chapter:</Text>
                <ChapterList
                  storyID={story?.id}
                  updateChapter={updateChapter}
                />
              </TooltipWrap>
            }
            interactive
            theme="light"
            arrow
            trigger="manual"
            placement="bottom-end"
            visible={isTooltipOpen}
          >
            <DetailHeaderButton iconcolor="#64748B" labelProps={{ color: '#64748B' }} label="Move to Chapter" icon={CgArrowRightR} onClick={() => setTooltipOpen(!isTooltipOpen)} />
          </Tippy>
          <DetailHeaderButton iconcolor={"#64748B"} labelProps={{ color: '#64748B' }} label="Delete Story" icon={FaRegTrashAlt} onClick={toggle} />
        </TooltipWrap>}
        interactive
        theme="light"
        arrow
        trigger="click"
        placement="bottom-end"
      >
        <Flex
          justifyContent="center"
          alignItems="center"
          ml={2}
          height="40px"
          width="40px"

          css="border-radius: 5px;background: #FFF;box-shadow: 0 0 5px 0 rgba(155, 89, 182, 0.15) inset; cursor: pointer;">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" fill="#9B59B6" stroke="#9B59B6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z" fill="#9B59B6" stroke="#9B59B6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z" fill="#9B59B6" stroke="#9B59B6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </Flex>
      </Tippy>}
    </Flex>
  )
}

const EditHeader = ({ story, cover }) => {

  const storyDate = useStoryDate(story);
  const coverUrl = getCoverUrl(story, cover);
  const { pathname } = useLocation()
  const { push } = useHistory();
  const [on, toggle] = useToggle();
  const [chapterName, setChapterName] = useState(null);

  const storyJournals = (story && story.journals) || [];

  const { entity: firstJournal } = useEntity(storyJournals ? storyJournals[0] : {});
  const { revalidate } = useJournalsChaptersSWR(firstJournal?.id);
  const { revalidate: revalidateJournal } = useSWR(`/v3/child_journals/${firstJournal.id}`)

  const isFromTellAStory = pathname?.includes('/tell_a_story')
  const [isTooltipOpen, setTooltipOpen] = useState(false);
  const wrapper = useRef(null);
  const allChapters = useEntities('chapter')
  const { openFirstTimeUserModal } = useDrawer();

  useOutsideClick(wrapper, () => {
    setTooltipOpen(false)
  });

  const { entity: currentChapter } = useEntity({ id: story?.['chapter-id'], type: 'chapter' });

  useEffect(() => {
    if (currentChapter?.name) {
      setChapterName(currentChapter?.name)
    }
  }, [currentChapter?.name])

  const handleEditSettingClick = () => {
    const basePath = isFromTellAStory ? '/tell_a_story' : '';
    push(`${basePath}/story/${story?.id}/edit/settings`);
  };

  const updateChapter = async (id, name) => {
    setChapterName(name)
    await updateStory(story?.id, bodyWithLockVersion(story, {
      'chapter-id': id
    }))
    setTooltipOpen(false)
    revalidate()
    revalidateJournal()
  }

  return (
    <Flex flexDirection="column" justifyContent="center" alignItems="center">
      {on && <DeleteModal onClose={toggle} />}

      <EditButtons storyId={story.id} />
      <HeaderWrap mt={[0, 0, 0, "60px"]} px={[2, 4]} py={2}>
        <Box width="100%" maxWidth={600} m="auto">
          <Flex justifyContent={(isFromTellAStory && !storyJournals) ? 'flex-start' : "space-between"} alignItems="center" mb={2}>
            {chapterName ? (
              <Flex alignItems="center" color="#000">
                <Text
                  textAlign="left" fontSize="16px" fontFamily="Poppins" color="#000" >
                  {chapterName}
                </Text>
              </Flex>
            ) : (Object.keys(allChapters || {}) || []).length === 0 ? null : <Tippy
              content={
                <TooltipWrap ref={wrapper}>
                  <Text fontFamily="Poppins" fontSize={18} py={2} lineHeight="165%" sx={{
                    boxShadow: '0px 1px 0px 0px #F0F0F0'
                  }}>Add to chapter:</Text>
                  <ChapterList
                    storyID={story?.id}
                    updateChapter={updateChapter}
                  />
                </TooltipWrap>
              }
              interactive
              theme="light"
              arrow
              trigger="manual"
              placement="bottom-end"
              visible={isTooltipOpen}
            >
              <DetailHeaderButton pl={0} p={0} size="unset" iconcolor="#9B59B6" labelProps={{ color: '#9B59B6' }} label="Add to Chapter" icon={BsPlusCircleFill} onClick={() => {
                openFirstTimeUserModal(() => setTooltipOpen(!isTooltipOpen))
              }} />
            </Tippy>}
            {storyDate && (
              <Text textAlign="right" fontSize="16px" fontFamily="Poppins" color="#64748B">
                {storyDate}
              </Text>
            )}
          </Flex>
          <Text
            sx={{
              color: '#000',
              fontFamily: 'Poppins',
              fontSize: '35px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '120%',
            }}>{isValidDateString(story.title) || `Untitled`}
          </Text>
          <EditorHeaderOptions
            story={story}
            isTooltipOpen={isTooltipOpen}
            setTooltipOpen={setTooltipOpen}
            handleEditSettingClick={handleEditSettingClick}
            updateChapter={updateChapter}
          />
        </Box>

      </HeaderWrap>
      {/* {coverUrl && <Image m="auto" maxWidth={600} sx={{
        borderRadius: '10px 10px 0px 0px'
      }} src={coverUrl || Default_PreviewPhoto} />} */}

    </Flex>
  );
};

EditHeader.propTypes = {
  story: PropTypes.shape({
    title: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
  cover: PropTypes.shape({}).isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  story: selectStory(state, ownProps.storyId),
  cover: selectStoryCover(state, ownProps.storyId),
});

export default connect(mapStateToProps)(EditHeader);
